




import { Component, Vue } from 'vue-property-decorator';
import Spinner from '@/components/ext/Spinner_new.vue';

@Component({
  components: {
    Spinner,
  },
})
export default class ComponetsOrdersComponetsOrderSpinner extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orders/OrderSpinner.vue